import { supabase } from '@/lib/supabase'
import type { Cohort, CohortCreate, CohortUpdate } from '@/types'

export async function fetchCohortsByDistrict(districtId: string): Promise<Cohort[]> {
  const { data, error } = await supabase
    .from('cohorts')
    .select('*')
    .eq('district_id', districtId)
    .order('population', { ascending: false })

  if (error) {
    throw error
  }

  return data as Cohort[]
}

export async function fetchCohortsByNation(nationId: string): Promise<Cohort[]> {
  const { data, error } = await supabase
    .from('cohorts')
    .select('*, district:districts!inner(region:regions!inner(nation_id))')
    .eq('district.region.nation_id', nationId)
    .order('population', { ascending: false })

  if (error) {
    throw error
  }

  return data as Cohort[]
}

export async function fetchCohort(id: string): Promise<Cohort> {
  const { data, error } = await supabase.from('cohorts').select('*').eq('id', id).single()

  if (error) {
    throw error
  }

  return data as Cohort
}

export async function createCohort(cohort: CohortCreate): Promise<Cohort> {
  const { data, error } = await supabase.from('cohorts').insert(cohort).select().single()

  if (error) {
    throw error
  }

  return data as Cohort
}

export async function updateCohort(id: string, updates: CohortUpdate): Promise<Cohort> {
  const { data, error } = await supabase
    .from('cohorts')
    .update(updates)
    .eq('id', id)
    .select()
    .single()

  if (error) {
    throw error
  }

  return data as Cohort
}

export async function bulkCreateCohorts(cohorts: CohortCreate[]): Promise<Cohort[]> {
  const { data, error } = await supabase.from('cohorts').insert(cohorts).select()

  if (error) {
    throw error
  }

  return data as Cohort[]
}

export async function deleteCohort(id: string): Promise<void> {
  const { error } = await supabase.from('cohorts').delete().eq('id', id)

  if (error) {
    throw error
  }
}

export async function deleteCohortsByDistrict(districtId: string): Promise<void> {
  const { error } = await supabase.from('cohorts').delete().eq('district_id', districtId)

  if (error) {
    throw error
  }
}
